module.exports = __webpack_public_path__ + "img/GEO.0d791af4.svg";